import React from 'react';
import { Timeline } from 'antd';
import { TimItem } from './views/time-item';

export const TimelineComponent = ({ timelineList, ...prop }) => {
  return <Timeline {...prop}>{timelineList?.map(TimItem)}</Timeline>;
};
